import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 text-center px-4">
      <span className="text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none leading-none">
        404
      </span>
      <div className="relative z-10 -mt-8 md:-mt-12">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-950">
          {t('common.notFound.title', 'Page not found')}
        </h1>
        <p className="mt-2 text-sm text-foreground-500">
          {t('common.notFound.subtitle', 'The page you are looking for does not exist.')}
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors"
        >
          <i className="ri-arrow-left-line"></i>
          {t('common.notFound.backHome', 'Back to home')}
        </Link>
      </div>
    </div>
  );
}